export default __webpack_public_path__ + "static/media/wranglr-logo.85cfb860.png";